export default __webpack_public_path__ + "static/media/Group 3056@2x.ab0e865a.png";